export const SUCCESS = 'success';
export const ALREADY_UNSUBSCRIBED = 'already_unsubscribed';
export const LINK_EXPIRED = 'link_expired';
export const PAGE_NOT_FOUND = 'page_not_found';
export const LOADING = 'loading';
export const RESUBSCRIBED = 'resubscribed';
export const FEEDBACK = 'feedback';
export const CONFIRM_UNSUBSCRIPTION = 'confirm_unsubscription';

export const routes = [ALREADY_UNSUBSCRIBED, LINK_EXPIRED, PAGE_NOT_FOUND, LOADING];
